import classNames from 'classnames';
import type { ReactNode } from 'react';

import { ColorThemedBlock } from '@/lib/color-theme/ColorThemedBlock';
import { ColorThemeProvider } from '@/lib/color-theme/ColorThemeProvider';
import type { PrimaryColor } from '@/lib/color-theme/types';
import { slugify } from '@/lib/util/strings/slugify';
import type { DataAttributes } from '@/types';

import styles from './Section.module.scss';

interface Props extends DataAttributes {
    children: ReactNode;
    isHero?: boolean;
    title?: string;
    primary: PrimaryColor | 'inherit';
    className?: string;
    backgroundUrl?: string;
    isEmbed?: boolean;
}

export function Section({
    children,
    title,
    primary,
    className: externalClassName,
    isHero,
    ...attributes
}: Props) {
    const className = classNames(
        styles.wrapper,
        {
            [styles.isHero]: isHero,
        },
        externalClassName,
    );

    if (primary === 'inherit') {
        return (
            <ColorThemedBlock {...attributes} as="section" className={className}>
                {children}
            </ColorThemedBlock>
        );
    }

    return (
        <ColorThemeProvider
            {...attributes}
            as="section"
            id={typeof title === 'string' ? slugify(title) : undefined}
            className={className}
            primary={primary}
            isBlock
        >
            {children}
        </ColorThemeProvider>
    );
}
